module.exports = __webpack_public_path__ + "static/media/kobiler-icin-sms.e811d7e5.jpg";